// todo: divide FormTypeEnum for login, common and email confirmation enums
export enum FormTypeEnum {
  Login = "login",
  LoginBeforeCall = "login-before-call",
  LoginOnAuthorizedOnlyPage = "login-on-authorized-only-page",
  LoginByEmail = "login_by_email",
  LoginAsExpert = "login_as_expert",
  CodeFromSMS = "code_from_sms",
  CodeFromMail = "code_from_mail",
  Questionnaire = "questionnaire",
  BirthDateQuestionnaire = "birth_date_questionnaire",
  PhoneQuestionnaire = "phone_questionnaire",
  Support = "support",
  Welcome = "welcome",
  Troubles = "troubles",
  EmailConfirmationSuccess = "email_confirmation_success",
  EmailConfirmationFailed = "email_confirmation_failed",
  StatusCodeReCaptchaError = "status_code_recaptcha_error",
  ReferralKeyError = "referral_key_error",
  Onboarding = "onboarding",
  Onboarding2 = "onboarding2",
  RelationOnboarding = "relation_onboarding",
  FinanceOnboarding = "finance_onboarding",
  CashBackInformation = "cashback_information",
  VideoSessionError = "video_session_error",
  BadgeInfo = "badge_info",
}

export enum LoginTypeEnum {
  LoginByPhone = "LoginByPhone",
  LoginByEmail = "LoginByEmail",
}

/** Контакт, на который ушёл одноразовый код: ровно то значение, что передали в sendCode */
export type SentContact = {
  loginType: LoginTypeEnum;
  value: string;
};

export interface LoginChangeForm {
  /** Сеттер флага первого входа (регистрации) */
  setIsFirstLoginCallback?: (value: boolean) => void;
}

export type LoginAcceptForm = {
  /** Какой контакт ждёт шаг кода: телефон для шага СМС, почту для шага письма */
  loginType: LoginTypeEnum;
  /** Flag indicating if login is first. Is undefined for expert login form */
  isFirstLogin?: boolean;
}
